import React from "react";
import { Link } from "react-router-dom";
import { MENU_ITEMS, QUICK_ACTION_ITEMS } from "./constants";
import {
  Announcements,
  Approvals,
  Checklist,
  TasksDetails,
} from "./Components";

const Home = () => {
  return (
    <div className="bg-gray-50 p-4 space-y-2">
      <div className="flex flex-col md:flex-row gap-4">
        {/* Division 1 for the menu */}
        <div className="bg-white shadow-md rounded-xl p-4 w-full">
          <div className="text-secondary text-xl font-bold text-center mb-4">
            Menu
          </div>
          <div className="flex justify-around items-center flex-wrap gap-4">
            {MENU_ITEMS.map(({ label, icon, color, link }) =>
              link ? (
                <Link
                  key={label}
                  to={link}
                  className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all cursor-pointer"
                >
                  <div
                    className={`w-12 h-12 md:w-10 md:h-10 ${color} bg-opacity-80 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-transform text-white`}
                  >
                    {icon}
                  </div>
                  <span className="text-md font-medium">{label}</span>
                </Link>
              ) : (
                <div
                  key={label}
                  className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all cursor-pointer"
                >
                  <div
                    className={`w-12 h-12 md:w-10 md:h-10 ${color} bg-opacity-80 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-transform text-white`}
                  >
                    {icon}
                  </div>
                  <span className="text-md font-medium">{label}</span>
                </div>
              )
            )}
          </div>
        </div>

        {/* Division 2 for quick actions */}
        <div className="bg-white shadow-md rounded-xl p-4 w-full">
          <div className="text-secondary text-xl font-bold text-center mb-4">
            Quick Actions
          </div>
          <div className="flex justify-around items-center flex-wrap gap-4">
            {QUICK_ACTION_ITEMS.map(({ label, icon, link }) =>
              link ? (
                <Link
                  key={label}
                  to={link}
                  className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all cursor-pointer"
                >
                  <div>
                    {icon}
                  </div>
                  <span className="text-md font-medium">{label}</span>
                </Link>
              ) : (
                <button
                  key={label}
                  className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all"
                >
                  {icon}
                  <span className="text-md font-medium">{label}</span>
                </button>
              )
            )}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 min-h-max max-h-[90%]">
        <Announcements />
        <Checklist />
        <TasksDetails />
        <Approvals />
      </div>
    </div>
  );
};

export default Home;
